/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Subtitle,
    SubtitleFromJSON,
    SubtitleFromJSONTyped,
    SubtitleToJSON,
} from './';

/**
 * 
 * @export
 * @interface EditorSubtitleUpdate
 */
export interface EditorSubtitleUpdate {
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitleUpdate
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitleUpdate
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitleUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitleUpdate
     */
    format?: string;
    /**
     * 
     * @type {Subtitle}
     * @memberof EditorSubtitleUpdate
     */
    subtitle: Subtitle;
}

export function EditorSubtitleUpdateFromJSON(json: any): EditorSubtitleUpdate {
    return EditorSubtitleUpdateFromJSONTyped(json, false);
}

export function EditorSubtitleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorSubtitleUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'subtitle': SubtitleFromJSON(json['subtitle']),
    };
}

export function EditorSubtitleUpdateToJSON(value?: EditorSubtitleUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'name': value.name,
        'format': value.format,
        'subtitle': SubtitleToJSON(value.subtitle),
    };
}


